import * as React from 'react';
import { clsx as cx } from 'clsx';
import * as styles from './CianLogo.css';

export const CianLogo = (props: React.HtmlHTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cx(styles['cian-logo'], props.className)} />
);
